import React from 'react';
import styles from './styles.module.scss';
import PropTypes from "prop-types";

const ModalSubtitle = React.memo(({ children }) => {
  return (
    <div className={styles.modalSubtitle}>
      {children}
    </div>
  );
});

ModalSubtitle.propTypes = {
  children: PropTypes.node.isRequired
};

ModalSubtitle.displayName = 'ModalSubtitle';

export default ModalSubtitle;
